module.exports = __webpack_public_path__ + "img/manage-applications-icon.c0698bd1.svg";